import Image from "next/image";

const PreferredSourceBadge = () => {
  const handleClick = () => {
    // Queued call works whether the SDK has already loaded or is still
    // loading (lazyOnload) - it opens Google's in-page dialog and returns
    // the user to this page, instead of navigating away.
    window.PREFERRED_SOURCE = window.PREFERRED_SOURCE || [];
    window.PREFERRED_SOURCE.push((preferredSource) => {
      preferredSource.addPreferredSource();
    });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Add TrooTech as a preferred source on Google Search"
      className="preferred-source-badge fixed z-50 bottom-5 left-5 shadow-lg cursor-pointer hover:opacity-90 hover:scale-105 active:scale-95 transition-all duration-200"
    >
      <Image
        src="/images/google_preferred_source_badge_light_en.png"
        alt="Add as Preferred Source"
        width={169}
        height={54}
        className="w-[140px] sm:w-[169px] h-auto"
      />
    </button>
  );
};

export default PreferredSourceBadge;
